// @flow
import React from 'react'
import styled from 'styled-components'
import ConstMap from 'frontend_core/dist/constants/map'
import { imagePath } from 'frontend_core/dist/helpers/image'

type PropTypes = {
  lat: number,
  lng: number,
  zoom?: number,
  url: string,
  googleMapReactBootstrapURLKeys?: ?Object,
}

const Container = styled.div`
  position: relative;
  height: 100%;
`

const MapFrame = styled.iframe`
  width: 100%;
  height: 100%;
`

function EmbeddedMap(props: PropTypes) {
  const lat = props.lat
  const lng = props.lng
  const zoom = props.zoom

  return (
    <Container>
      <MapFrame
        width="600"
        height="450"
        frameborder="0"
        src={`https://www.google.com/maps/embed/v1/place?key=${
          props.googleMapReactBootstrapURLKeys.key
        }&q=${lat || ConstMap.defaultLatitude},${lng ||
          ConstMap.defaultLongitude}`}
      />
    </Container>
  )
}
EmbeddedMap.defaultProps = {
  lat: ConstMap.defaultLatitude,
  lng: ConstMap.defaultLongitude,
  zoom: ConstMap.defaultZoom,
}

export default EmbeddedMap



// WEBPACK FOOTER //
// ./src/components/shared/EmbeddedMap.jsx